var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BusinessProduct',{attrs:{"showDialog":_vm.dialogProduct,"bussId":parseInt(_vm.authMod.user.user.info.coso_id)},on:{"confirmed":_vm.onProductConfirmed,"cancelled":_vm.onProductCancelled}})
}
var staticRenderFns = []

export { render, staticRenderFns }